export default "__VITE_ASSET__UpThFFOv__"